import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './award-section.module.css';
import Award from './award';


export class AwardsComponent extends Component {
  static propTypes = {
    header: PropTypes.string,
    awards: PropTypes.array
  };

  render() {
    const {awards, header} = this.props;
    if (awards?.length > 0) {
      return (
        <span>
          <h2 className={styles.locationHeader}>{header}</h2>
          { awards }
        </span>
      );
    };
    return <div></div>;
  }

}

export class AwardSection extends Component {
  static propTypes = {
    header: PropTypes.string,
    children: PropTypes.object,
    awards: PropTypes.array
  };
  render() {
    const { header, children, awards } = this.props;
    if (awards?.length > 0) {
      return (
        <div className={styles.awardsSection}>
          {header ? (
            <h4 className={styles.header}>
              <span className={styles.textWrapper}>
                {header} {children.length > 1 && <span className={styles.count}>{children.length}</span>}
              </span>
            </h4>
          ) : null}
          {children}
        </div>
      );
    } else {
      return(
        <h1>No awards found.</h1>
      )
    }
  }
}
